import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'addin-header',
  templateUrl: './addin-header.component.html',
  styleUrls: ['./addin-header.component.scss'],
  imports: [NgClass],
})
/**
 * Represents the header component for the add-in.
 * Displays the product name and indicates if the application is in demo mode.
 *
 * @property productName - The name of the product to display in the header.
 * @property isDemoMode - Flag indicating whether the application is running in demo mode.
 */
export class AddinHeaderComponent {
  @Input()
  productName: any;
  @Input()
  isDemoMode: boolean = false;
}
